import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { MainContext } from '../../../Contexts/MainContext';
import { BUSINESS } from '../../../Legal/legalContent';
import './Footer.scss';

const POLICY_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
  { to: '/terms', label: 'Terms' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/refund-policy', label: 'Refunds' },
  { to: '/shipping-policy', label: 'Shipping' },
];

function FooterWave() {
  return (
    <div className="la-mob-footer__wave" aria-hidden="true">
      <svg
        className="la-mob-footer__wave-svg"
        viewBox="0 0 1440 56"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="la-mob-footer__wave-fill"
          d="M0 28
             C120 8 240 48 360 32
             C480 16 600 4 720 20
             C840 36 960 52 1080 36
             C1200 20 1320 8 1440 24
             L1440 56
             L0 56
             Z"
        />
      </svg>
    </div>
  );
}

export function MobFooter() {
  const { lockFooter } = useContext(MainContext) || {};
  const year = new Date().getFullYear();

  if (lockFooter === true) return null;

  return (
    <footer className="la-mob-footer">
      <FooterWave />

      <div className="la-mob-footer__panel">
        <div className="la-mob-footer__body">
          <p className="la-mob-footer__brand">{BUSINESS.brandName}</p>
          <p className="la-mob-footer__tag">{BUSINESS.tagline}</p>

          <nav className="la-mob-footer__links" aria-label="Footer links">
            {POLICY_LINKS.map((link) => (
              <Link key={link.to} to={link.to} className="la-mob-footer__link">
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="la-mob-footer__contact">
            <a href={BUSINESS.mailtoHref} x-apple-data-detectors="false">
              {BUSINESS.email}
            </a>
            <a href={BUSINESS.telHref} x-apple-data-detectors="false">
              {BUSINESS.phone}
            </a>
          </div>
        </div>

        <div className="la-mob-footer__legal">
          © {year} {BUSINESS.brandName} · Operated by {BUSINESS.legalName}
        </div>
      </div>
    </footer>
  );
}
